function getCurrentTime(): string {
  return new Date().toISOString();
}
export { getCurrentTime };
